
    	// init controller
	var controller = new ScrollMagic.Controller();


		// Bean One
		new ScrollMagic.Scene({
							triggerElement: "#bean_one_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_one_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean Two
		new ScrollMagic.Scene({
							triggerElement: "#bean_two_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 400, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_two_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);


		// Bean Three
		new ScrollMagic.Scene({
							triggerElement: "#bean_three_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_three_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);


		// Bean four
		new ScrollMagic.Scene({
							triggerElement: "#bean_four_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 100, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_four_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean five
		new ScrollMagic.Scene({
							triggerElement: "#bean_five_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 150, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_five_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean six
		new ScrollMagic.Scene({
							triggerElement: "#bean_six_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_six_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean seven
		new ScrollMagic.Scene({
							triggerElement: "#bean_seven_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_seven_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);




		// Bean eight
		new ScrollMagic.Scene({
							triggerElement: "#bean_eight_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:250, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_eight_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);




		// Bean nine
		new ScrollMagic.Scene({
							triggerElement: "#bean_nine_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_nine_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean ten
		new ScrollMagic.Scene({
							triggerElement: "#bean_ten_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:250, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_ten_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean eleven
		new ScrollMagic.Scene({
							triggerElement: "#bean_eleven_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_eleven_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);




		// Bean twelve
		new ScrollMagic.Scene({
							triggerElement: "#bean_twelve_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:250, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_twelve_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean thirteen
		new ScrollMagic.Scene({
							triggerElement: "#bean_thirteen_trigger",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset:200, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_thirteen_reveal", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);









// DESKTOP BEAN SETTINGS


		// Bean One
		new ScrollMagic.Scene({
							triggerElement: "#bean_one_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 500, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_one_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean three
		new ScrollMagic.Scene({
							triggerElement: "#bean_three_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 250, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_three_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);


		// Bean two
		new ScrollMagic.Scene({
							triggerElement: "#bean_two_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 500, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_two_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);





		// Bean four
		new ScrollMagic.Scene({
							triggerElement: "#bean_four_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 600, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_four_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);





		// Bean five
		new ScrollMagic.Scene({
							triggerElement: "#bean_five_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 700, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_five_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);





		// Bean six
		new ScrollMagic.Scene({
							triggerElement: "#bean_six_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 1050, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_six_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);





		// Bean eight
		new ScrollMagic.Scene({
							triggerElement: "#bean_eight_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 350, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_eight_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean photo one
		new ScrollMagic.Scene({
							triggerElement: "#bean_photo_one_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 350, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_photo_one_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean photo two
		new ScrollMagic.Scene({
							triggerElement: "#bean_photo_two_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 450, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_photo_two_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);



		// Bean photo three
		new ScrollMagic.Scene({
							triggerElement: "#bean_photo_three_trigger_desktop",
							triggerHook: 0.9,
                            duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
							offset: 550, // move trigger to center of element
							reverse: true
						})
						.setClassToggle("#bean_photo_three_reveal_desktop", "visible") // add class toggle
						.addIndicators() // add indicators (requires plugin)
						.addTo(controller);

